export default {
    path: '/getPaper',
    meta: {
        title: '兑换积分红包',
        scrollTop:0,
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/getPaper`),
}



// WEBPACK FOOTER //
// ./src/views/getPaper/router.js